interface Config {
  logoutRedirectUrl: string;
  supportCentreUrl: string;
}

const config: Config = {
  logoutRedirectUrl: "https://dexibit.com",
  supportCentreUrl: "https://support.dexibit.com",
};

export default config;
